import { createAction } from 'redux-act';

interface MemberPayload {
  memberId: null | string;
  title: null | string;
  firstName: null | string;
  lastName: null | string;
  pointsBalance: null | string;
  membershipTier: null | string;
  token: null | string;
  isAuthenticated: boolean;
  hasInitializedSSO?: boolean;
}

export const ssoInitCompleted = createAction<MemberPayload | undefined>('ssoUser/INIT_COMPLETED');
export const ssoLoginSuccess = createAction<MemberPayload | undefined>('ssoUser/LOGIN_SUCCESS');
export const ssoLogoutSuccess = createAction('ssoUser/LOGOUT_SUCCESS');
export const ssoSyncProfile = createAction('ssoUser/PROFILE_SYNC_SUCCESS');
